module.exports = __webpack_public_path__ + "img/katarina_bedrooms_5.2f9bef79.jpg";